// Helper function to format date and time for display with abbreviated timezone
import { parseISO } from "date-fns"
import { format, toZonedTime } from "date-fns-tz"

export const formatEventDateTime = (
  dateTimeString: string,
  timezone?: string
) => {
  const date = parseISO(dateTimeString)

  // Use specified timezone or default to system timezone
  const zonedDate = timezone ? toZonedTime(date, timezone) : date

  // Format the date with the abbreviated timezone (e.g., "GMT", "EST", "CST")
  return format(
    zonedDate,
    "EEE, MMM d • h:mm a z",
    timezone ? { timeZone: timezone } : undefined
  )
}
